import { urls } from './';

const sequences = {
	missao: {
		images: [
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00000.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00001.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00002.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00003.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00004.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00005.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00006.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00007.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00008.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00009.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00010.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00011.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00012.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00013.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00014.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00015.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00016.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00017.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00018.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00019.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00020.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00021.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00022.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00023.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00024.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00025.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00026.png',
			urls.assets + 'img/sequences/missao/Vector Smart Object copy 3.anima missao_00027.png'
		]
	},
	visao: {
		images: [
			urls.assets + 'img/sequences/visao/Background.anima visao_00000.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00001.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00002.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00003.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00004.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00005.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00006.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00007.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00008.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00009.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00010.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00011.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00012.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00013.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00014.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00015.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00016.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00017.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00018.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00019.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00020.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00021.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00022.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00023.png',
			urls.assets + 'img/sequences/visao/Background.anima visao_00024.png'
		]
	},
	valores: {
		images: [
			urls.assets + 'img/sequences/visao/Background.anima valores_00000.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00001.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00002.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00003.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00004.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00005.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00006.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00007.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00008.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00009.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00010.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00011.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00012.png',
			urls.assets + 'img/sequences/visao/Background.anima valores_00013.png'
		]
	},
	transition: { 
		images: [
			urls.assets + 'images/sequences/transition/transicao_00000.png',
			urls.assets + 'images/sequences/transition/transicao_00001.png',
			urls.assets + 'images/sequences/transition/transicao_00002.png',
			urls.assets + 'images/sequences/transition/transicao_00003.png',
			urls.assets + 'images/sequences/transition/transicao_00004.png',
			urls.assets + 'images/sequences/transition/transicao_00005.png',
			urls.assets + 'images/sequences/transition/transicao_00006.png',
			urls.assets + 'images/sequences/transition/transicao_00007.png',
			urls.assets + 'images/sequences/transition/transicao_00008.png',
			urls.assets + 'images/sequences/transition/transicao_00009.png',
			urls.assets + 'images/sequences/transition/transicao_00010.png',
			urls.assets + 'images/sequences/transition/transicao_00011.png',
			urls.assets + 'images/sequences/transition/transicao_00012.png',
			urls.assets + 'images/sequences/transition/transicao_00013.png',
			urls.assets + 'images/sequences/transition/transicao_00014.png',
			urls.assets + 'images/sequences/transition/transicao_00015.png',
			urls.assets + 'images/sequences/transition/transicao_00016.png',
			urls.assets + 'images/sequences/transition/transicao_00017.png',
			urls.assets + 'images/sequences/transition/transicao_00018.png',
			urls.assets + 'images/sequences/transition/transicao_00019.png',
			urls.assets + 'images/sequences/transition/transicao_00020.png',
			urls.assets + 'images/sequences/transition/transicao_00021.png',
			urls.assets + 'images/sequences/transition/transicao_00022.png',
			urls.assets + 'images/sequences/transition/transicao_00023.png',
			urls.assets + 'images/sequences/transition/transicao_00024.png',
			urls.assets + 'images/sequences/transition/transicao_00025.png',
			urls.assets + 'images/sequences/transition/transicao_00026.png',
			urls.assets + 'images/sequences/transition/transicao_00027.png',
			urls.assets + 'images/sequences/transition/transicao_00028.png',
			urls.assets + 'images/sequences/transition/transicao_00029.png',
			urls.assets + 'images/sequences/transition/transicao_00030.png',
			urls.assets + 'images/sequences/transition/transicao_00031.png',
			urls.assets + 'images/sequences/transition/transicao_00032.png',
			urls.assets + 'images/sequences/transition/transicao_00033.png',
			urls.assets + 'images/sequences/transition/transicao_00034.png',
			urls.assets + 'images/sequences/transition/transicao_00035.png',
			urls.assets + 'images/sequences/transition/transicao_00036.png',
			urls.assets + 'images/sequences/transition/transicao_00037.png',
			urls.assets + 'images/sequences/transition/transicao_00038.png',
			urls.assets + 'images/sequences/transition/transicao_00039.png',
			urls.assets + 'images/sequences/transition/transicao_00040.png',
			urls.assets + 'images/sequences/transition/transicao_00041.png',
			urls.assets + 'images/sequences/transition/transicao_00042.png',
			urls.assets + 'images/sequences/transition/transicao_00043.png',
			urls.assets + 'images/sequences/transition/transicao_00044.png',
			urls.assets + 'images/sequences/transition/transicao_00045.png',
			urls.assets + 'images/sequences/transition/transicao_00046.png',
			urls.assets + 'images/sequences/transition/transicao_00047.png',
			urls.assets + 'images/sequences/transition/transicao_00048.png',
			urls.assets + 'images/sequences/transition/transicao_00049.png',
			urls.assets + 'images/sequences/transition/transicao_00050.png',
			urls.assets + 'images/sequences/transition/transicao_00051.png',
			urls.assets + 'images/sequences/transition/transicao_00052.png',
			urls.assets + 'images/sequences/transition/transicao_00053.png',
			urls.assets + 'images/sequences/transition/transicao_00054.png',
			urls.assets + 'images/sequences/transition/transicao_00055.png',
			urls.assets + 'images/sequences/transition/transicao_00056.png',
			urls.assets + 'images/sequences/transition/transicao_00057.png',
			urls.assets + 'images/sequences/transition/transicao_00058.png',
			urls.assets + 'images/sequences/transition/transicao_00059.png',
			urls.assets + 'images/sequences/transition/transicao_00060.png',
			urls.assets + 'images/sequences/transition/transicao_00061.png',
			urls.assets + 'images/sequences/transition/transicao_00062.png',
			urls.assets + 'images/sequences/transition/transicao_00063.png',
			urls.assets + 'images/sequences/transition/transicao_00064.png',
			urls.assets + 'images/sequences/transition/transicao_00065.png',
			urls.assets + 'images/sequences/transition/transicao_00066.png',
			urls.assets + 'images/sequences/transition/transicao_00067.png',
			urls.assets + 'images/sequences/transition/transicao_00068.png',
			urls.assets + 'images/sequences/transition/transicao_00069.png'
		]
	}
};

export { sequences };